import { useEffect, useState } from "react";

export default function Announcements() {
  const [valid, isValid] = useState(false);
  const [msg, setMsg] = useState("");
  const [goto, setHref] = useState(undefined);
  useEffect((e) => {
    fetch("https://api-legacy.mmods.es/v2/downloads/get_avisos.php", {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
      },
    })
      .then((data) => data.json())
      .then((data) => {
        if (data.status) {
          if (data.data.href) {
            setMsg(
              <a
                className="invisible-link"
                target={"_blank"}
                rel="noreferrer"
                href={data.data.href}
              >
                {data.data.msg}
              </a>,
            );
          } else {
            setMsg(data.data.msg);
          }
          isValid(true);
        } else {
          isValid(false);
        }
      });
  }, []);
  if (valid) {
    return (
      <>
        <div className="announcement">{msg}</div>
      </>
    );
  } else {
    return <></>;
  }
}
